import { render, staticRenderFns } from "./SettingsRoleAddPage.vue?vue&type=template&id=8a5acb0e"
import script from "./SettingsRoleAddPage.vue?vue&type=script&lang=ts"
export * from "./SettingsRoleAddPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsRoleAddPage.vue?vue&type=style&index=0&id=8a5acb0e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports